function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M0 85.331h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M330.207 85.331H512v341.337H330.207z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.331h181.793v341.337H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M315.362 219.607H274.55c0-10.244-8.306-18.551-18.551-18.551-10.246 0-18.551 8.306-18.551 18.551h-40.812c0 10.088 8.787 18.265 18.874 18.265h-.608c0 10.088 8.176 18.266 18.265 18.266 0 8.931 6.414 16.353 14.886 17.939l-14.393 32.495c6.896 2.804 14.434 4.362 22.338 4.362s15.441-1.558 22.338-4.362l-14.392-32.495c8.471-1.586 14.886-9.008 14.886-17.939 10.089 0 18.265-8.179 18.265-18.266h-.609c10.09-.001 18.876-8.179 18.876-18.265z",
  fill: "#ff9811"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M256 244.864l-24.116 11.13v22.261L256 293.095l24.116-14.84v-22.261z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M231.88 233.734h48.228v22.261H231.88z"
});

const SvgMoldova = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoldova, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/moldova.5bf2a3db.svg";
export { ForwardRef as ReactComponent };